"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.incomeSourceType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _profileTypes = require("./profile-types");

var incomeSourceType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  employer: _propTypes.default.string,
  amount: _propTypes.default.number,
  employmentType: _propTypes.default.string,
  // enum: [ UNKNOWN, EMPLOYED, SELF_EMPLOYED, OTHER ]
  employerAddress: _profileTypes.addressType
});

exports.incomeSourceType = incomeSourceType;